import { render, staticRenderFns } from "./store-view.vue?vue&type=template&id=45bcd1c7&scoped=true"
import script from "./store-view.vue?vue&type=script&lang=ts"
export * from "./store-view.vue?vue&type=script&lang=ts"
import style0 from "./store-view.vue?vue&type=style&index=0&id=45bcd1c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bcd1c7",
  null
  
)

export default component.exports